import Vue from "vue";
import ModalConfirm from "@/components/modal-confirm/";
const global = {};
Vue.prototype.$global = global;
Vue.use(ModalConfirm, {
  global: Vue.prototype.$global,
});
